{
  "tabsAriaLabel": "SMS-mottakere navigasjon",
  "title": "Masseutsendelse av SMS",
  "description": "Send SMS til flere mottakere samtidig",
  "tabs": {
    "filteredRecipients": "Filtrert mottakerliste",
    "manualRecipients": "Manuell mottakerliste"
  },
  "filteredRecipients": {
    "messageType": {
      "title": "Meldingstype",
      "description": "Velg hva slags melding som skal sendes",
      "options": {
        "general": {
          "label": "Generell informasjon",
          "description": "Omfatter ting som nyheter, invitasjoner til arrangementer og annet"
        },
        "important": {
          "label": "Viktig informasjon",
          "description": "Sendes til alle berørte mottakere, også de som har reservert seg mot generell informasjon"
        }
      }
    },
    "targetGroup": {
      "title": "Målgruppe",
      "description": "Velg en målgruppe for meldingen",
      "options": {
        "allForestOwners": {
          "label": "Alle skogeiere"
        },
        "shareholders": {
          "label": "Andelseiere"
        },
        "nonShareholders": {
          "label": "Ikke andelseiere"
        },
        "allEmployees": {
          "label": "Alle ansatte"
        }
      }
    },
    "recipient": {
      "title": "Mottaker",
      "description": "Velg hvem som skal motta meldingen",
      "addButton": "Velg mottakere",
      "zeroRecipientsWarning": "Ingen mottakere funnet med valgte filtre. Du kan sende en kopi til deg selv ved å velge \"Send en kopi til meg\"."
    },
    "message": {
      "title": "Melding",
      "description": "Skriv meldingen du ønsker å sende",
      "placeholder": "Skriv her..."
    },
    "recipientSummary": {
      "title": "Valgt mottaker",
      "titleWithCount": "{{count}} valgte mottakere",
      "municipalities": "Kommuner",
      "forestOwnerGroups": "Skogeierlag",
      "offices": "Kontor",
      "registeredBetween": "Registrert mellom",
      "registeredFrom": "Registrert fra",
      "registeredTo": "Registrert til"
    },
    "dialogs": {
      "common": {
        "title": "Velg mottaker",
        "saveButton": "Lagre mottaker"
      },
      "forestOwners": {
        "description": "Velg hvilke skogeiere som skal motta meldingen",
        "content": "Innhold for valg av skogeiere kommer her",
        "municipalitiesLabel": "Områder",
        "municipalitiesDescription": "Legg til en eller flere kommuner",
        "moreOptions": "Flere valgalternativer",
        "registeredBetweenLabel": "Registrert mellom (valgfritt)",
        "registeredBetweenDescription": "Begrens mottakere basert på når de ble registrert",
        "allMunicipalities": "Alle kommuner",
        "allMunicipalitiesSelected": "Listen er tom - alle kommuner er valgt"
      },
      "shareholders": {
        "forestOwnerGroupsLabel": "Skogeierlag",
        "forestOwnerGroupsDescription": "Legg til et eller flere skogeierlag",
        "allForestOwnerGroups": "Alle skogeierlag",
        "allForestOwnerGroupsSelected": "Listen er tom - alle skogeierlag er valgt",
        "areaType": {
          "title": "Områdegrunnlag",
          "description": "Velg om meldingen skal sendes til mottakere basert på geografisk område eller skogeierlag",
          "options": {
            "municipalities": {
              "label": "Kommuner/geografiske områder",
              "description": "Send til mottakere i en eller flere kommuner"
            },
            "forestOwnerAssociation": {
              "label": "Skogeierlag",
              "description": "Send til mottakere som tilhører skogeierlag"
            }
          }
        }
      },
      "employees": {
        "content": "Innhold for valg av ansatte kommer her",
        "officesLabel": "Kontor",
        "officesDescription": "Velg ett eller flere kontorer",
        "officesPlaceholder": "Velg kontor...",
        "officesLoading": "Laster kontorer...",
        "loadOfficesError": "Kunne ikke laste kontorer",
        "noOfficesFound": "Ingen kontorer funnet",
        "allOfficesSelected": "Listen er tom - alle kontorer er valgt",
        "allOffices": "Alle kontorer"
      }
    },
    "changeConfirmation": {
      "title": "Ønsker du å endre målgruppe?",
      "description": "Hvis du endrer målgruppe, blir valgene for mottakere tilbakestilt. Du må velge mottakere på nytt etterpå.",
      "confirmButton": "Endre målgruppe"
    },
    "sendConfirmation": {
      "title": "Send SMS til {{count}} mottakere?",
      "description": "Meldingen kan ikke trekkes tilbake",
      "confirmButton": "Send SMS"
    }
  },
  "common": {
    "sendCopyLabel": "Send en kopi til meg",
    "sendCopyDescription": "Brukes for å kontrollere at meldingen kommer frem",
    "sendButton": "Send SMS",
    "successTitle": "SMS er sendt",
    "successDescription": "Sendingen av meldingen var vellykket",
    "sendAnotherButton": "Send ny melding",
    "characters": "tegn",
    "sms": "SMS",
    "longMessageWarningTitle": "SMS kostnaden øker ved lange meldinger!",
    "longMessageWarningDescription": "Meldingen er lengre enn en SMS (160 tegn) og blir derfor delt opp i flere ved sending. Mottakeren får den som en sammenhengende melding, men kostnaden øker for hver sendte SMS."
  },
  "validation": {
    "messageEmpty": "Meldingen kan ikke være tom. Skriv inn teksten du vil sende",
    "messageTooLong": "Meldingen kan ikke være lengre enn {{maxChars}} tegn",
    "messageTypeRequired": "Meldingstype må velges",
    "targetGroupRequired": "Målgruppe må velges",
    "recipientsRequired": "Mottakere må velges",
    "recipientsInvalid": "Kunne ikke validere mottakerlisten",
    "phoneNumbersRequired": "Meldingen har ingen mottakere. Fyll inn mobilnumrene du ønsker å sende til",
    "phoneNumbersInvalid": "Ett eller flere av numrene har ikke 8 sifre. Sjekk listen og prøv igjen.",
    "municipalitiesRequired": "Velg minst én kommune",
    "officesRequired": "Velg minst ett kontor",
    "areaTypeRequired": "Velg minst ett område",
    "forestOwnerGroupsRequired": "Velg minst ett skogeierlag"
  },
  "errors": {
    "sendFailed": "Kunne ikke sende SMS",
    "fetchRecipientsFailed": "Kunne ikke hente mottakere",
    "tryAgainLater": "Vennligst prøv igjen senere."
  },
  "manualRecipients": {
    "title": "Mobilnummere",
    "description": "Fyll inn numrene du ønsker å sende til. Bruk semikolon (;) mellom hvert nummer.",
    "messageTitle": "Melding",
    "messageDescription": "Skriv meldingen du ønsker å sende",
    "messagePlaceholder": "Skriv her..."
  }
}
